import React from "react";
import { useHooks } from "./hooks";

export const MojPlugin = React.memo(({ on }: { on: boolean }) => {
  useHooks(on);

  return <></>;
});
